export const demoEn = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Play Now — Enter Grymwyrd',
  'demo.seoDescription':
    'Spin the world, claim a seat at the table, forge a Grymwyrd hero, and roll the bones — a guided tour of the Grymwyrd virtual tabletop.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'The world of Grymwyrd',
  'demo.globe.spinningWorld': 'Spinning the world…',
  'demo.globe.tagline': 'A living horror-fantasy world',
  'demo.globe.arrivedHeading': 'Greywick Region',
  'demo.globe.heading': 'Find your place in the eternal twilight',
  'demo.globe.subheading': 'A table waits at the heart of the world. Take your seat and forge a hero.',
  'demo.globe.enterCta': 'Descend into Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Become a part of the story',
  'demo.account.subheading':
    "Create a free account to unlock the full Grymwyrd encyclopedia and save the hero you're about to forge — or step through as a guest and explore now.",
  'demo.account.createAccount': 'Create an account',
  'demo.account.logIn': 'Log in',
  'demo.account.continueAsGuest': 'Continue as a guest',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': 'Initiative',
  'demo.create.lobbyEyebrow': 'Grymwyrd Virtual Tabletop · Lobby',
  'demo.create.heading': 'Forge your hero',
  'demo.create.subheading': 'An SRD 5.2.1 character, born of Grymwyrd. Name them, choose a calling, and roll the bones.',
  'demo.create.nameLabel': 'Name',
  'demo.create.namePlaceholder': 'Who do they become?',
  'demo.create.chooseCalling': 'Choose your calling',
  'demo.create.keyAbility': 'Key: {ability}',
  'demo.create.abilityScores': 'Ability scores',
  'demo.create.abilityScoresHint': '— click to roll 3d6',
  'demo.create.rollAbilityAria': 'Roll {ability} (3d6)',
  'demo.create.keepStandard': 'Or keep the standard 10s and dive in.',
  'demo.create.initiativeResult': 'Initiative {initiative} — roll the bones, the table turns to you…',
  'demo.create.bonesTumble': 'The bones tumble…',
  'demo.create.rollInitiativeCta': 'Roll for initiative & take your seat',
  'demo.create.chooseCallingHint': 'Choose a calling to take your seat.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'The table couldn’t be set',
  'demo.table.errorBody': 'The tabletop is unavailable right now.',
  'demo.table.browseLiveTables': 'Browse live tables instead',
  'demo.table.settingTable': 'Setting your table…',
  'demo.table.connecting': 'Connecting to the tabletop…',
  'demo.table.heroTable': "{name}'s table",
  'demo.table.firstTable': 'Your first table',
  'demo.table.diceTrayHeading': 'Dice tray',
  'demo.table.initiativeHeading': 'Initiative',
  'demo.table.initiativePrompt': 'Roll the bones to set the order of battle.',
  'demo.table.rollForInitiative': 'Roll for initiative',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'Pause the game, anonymously',
  'demo.table.xcard': 'X-Card',
  'demo.table.saveHeroTitle': 'Create a free account to save your hero',
  'demo.table.saveHero': 'Save hero',
  'demo.table.statusLive': 'Live',
  'demo.table.statusConnecting': 'Connecting',
  'demo.table.actionLogHeading': 'Action log',
  'demo.table.recentRollsHeading': 'Recent rolls',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Hero Sheet',
  'demo.panel.companion': 'Companion',
  'demo.panel.diceTray': 'Dice Tray',
  'demo.panel.macros': 'Macros',
  'demo.panel.diceConsole': 'Dice Console',
  'demo.panel.initiative': 'Initiative',
  'demo.panel.poll': 'Poll',
  'demo.panel.recentRolls': 'Recent Rolls',
  'demo.panel.reference': 'Reference',
  'demo.panel.chat': 'Chat',
  'demo.panel.handouts': 'Handouts',
  'demo.panel.safety': 'Safety',
  'demo.panel.sceneAndCues': 'Scene & Cues',
  'demo.panel.replay': 'Replay',
  'demo.panel.recap': 'Recap',
  'demo.panel.actionLog': 'Action Log',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Melee',
  'demo.action.cast': 'Cast',
  'demo.action.move': 'Move',
  'demo.action.block': 'Block',
  'demo.action.chooseTarget': 'Choose a target for {action}…',
  'demo.action.controlling': 'Controlling:',
  'demo.action.cannotAct': '{label} can’t act — select a mob, player, vehicle, or NPC.',
  'demo.action.selectActionable': 'Select an actionable object to act with it.',
  'demo.action.cancel': 'Cancel',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Rolling the order…',
  'demo.tracker.combatant': 'Combatant {n}',
  'demo.tracker.previousTurn': 'Previous turn',
  'demo.tracker.round': 'Round {round}',
  'demo.tracker.endCombatTitle': 'End combat',
  'demo.tracker.end': 'End',
  'demo.tracker.nextTurnTitle': 'Next turn',
  'demo.tracker.next': 'Next',
  'demo.tracker.hitPoints': 'Hit points',
  'demo.tracker.reduceHp': 'Reduce {name} HP',
  'demo.tracker.raiseHp': 'Raise {name} HP',
  'demo.tracker.addStatusEffect': 'Add a status effect',
  'demo.tracker.removeFromOrder': 'Remove from order',
  'demo.tracker.removeFromOrderTitle': 'Remove from the order',
  'demo.tracker.removeCondition': 'Remove {name}',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'The table is paused',
  'demo.xcard.heading': 'The table is paused',
  'demo.xcard.body':
    'Someone raised the X-card. We pause, no questions asked and no one named. When everyone’s ready, carry on.',
  'demo.xcard.resume': 'We’re ready — resume',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Handouts',
  'demo.handouts.titlePlaceholder': 'Title (optional)',
  'demo.handouts.bodyPlaceholder': 'A note, a clue, a read-aloud…',
  'demo.handouts.push': 'Push to the table',
  'demo.handouts.whispered': 'Whispered',
  'demo.handouts.dismiss': 'Dismiss handout',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Safety',
  'demo.safety.description': 'Lines we won’t cross; veils we draw over. Shared by the whole table, never attributed.',
  'demo.safety.linesLabel': 'Lines (hard no)',
  'demo.safety.veilsLabel': 'Veils (fade to black)',
  'demo.safety.removeItem': 'Remove “{item}”',
  'demo.safety.addLinePlaceholder': 'Add a line…',
  'demo.safety.addVeilPlaceholder': 'Add a veil…',
  'demo.safety.addLine': 'Add line',
  'demo.safety.addVeil': 'Add veil',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Hero Sheet',
  'demo.sheet.hp': 'HP',
  'demo.sheet.ac': 'AC',
  'demo.sheet.classLevel': '{className} · Lv 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Companion device',
  'demo.companion.description':
    'Pair a phone or tablet as a read-only second screen — initiative, recent rolls, and the scene mirror to the device. Revoke any time.',
  'demo.companion.pairDevice': 'Pair a device',
  'demo.companion.qrAriaLabel': 'Companion pairing QR code',
  'demo.companion.copied': 'Copied',
  'demo.companion.copyLink': 'Copy link',
  'demo.companion.revoke': 'Revoke',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Dice Macros',
  'demo.macros.dismissError': 'Dismiss error',
  'demo.macros.newMacro': 'New macro',
  'demo.macros.namePlaceholder': 'Name (no dots)',
  'demo.macros.labelPlaceholder': 'Button label (optional)',
  'demo.macros.save': 'Save macro',
  'demo.macros.noDots': 'Macro names cannot contain dots.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Poll',
  'demo.poll.questionPlaceholder': 'Ask the table…',
  'demo.poll.optionPlaceholder': 'Option {n}',
  'demo.poll.removeOption': 'Remove option {n}',
  'demo.poll.addOption': 'Add option',
  'demo.poll.openPoll': 'Open poll',
  'demo.poll.live': 'Live',
  'demo.poll.closed': 'Poll closed',
  'demo.poll.vote': 'Vote',
  'demo.poll.closePoll': 'Close poll',
  'demo.poll.startNewPoll': 'Start a new poll',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Session recap',
  'demo.recap.tagline': 'Your table’s tale, when the dust settles.',
  'demo.recap.gathering': 'Gathering the tale…',
  'demo.recap.getRecap': 'Get the session recap',
  'demo.recap.notableRolls': 'Notable rolls',
  'demo.recap.copied': 'Copied!',
  'demo.recap.share': 'Share',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Reference',
  'demo.reference.searchPlaceholder': 'Look up a monster, spell, rule…',
  'demo.reference.searchAria': 'Search the encyclopedia to share',
  'demo.reference.typeToSearch': 'Type at least two letters to search the living encyclopedia.',
  'demo.reference.searching': 'Searching…',
  'demo.reference.open': 'Open {title}',
  'demo.reference.share': 'Share',
  'demo.reference.dismiss': 'Dismiss reference',
  'demo.reference.backToSearch': 'Back to search',
  'demo.reference.loadingContent': 'Loading content…',
  'demo.reference.notOwned':
    'You don’t own this book yet. The full reference unlocks once you add it to your library.',
  'demo.reference.contentDown': 'Content is unavailable right now. Try again in a moment.',
  'demo.reference.noAdditionalContent': 'No additional content for this reference.',
  'demo.reference.noLinkedContent': 'No linked book content for this reference.',
  'demo.reference.shareToTable': 'Share to table',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Replay',
  'demo.replay.tagline': 'Walk back through the session beat by beat.',
  'demo.replay.loading': 'Loading…',
  'demo.replay.loadReplay': 'Load replay',
  'demo.replay.loadMore': 'Load more',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Dice',
  'demo.dice.dismissError': 'Dismiss error',
  'demo.dice.labelPlaceholder': 'Attack (optional)',
  'demo.dice.roll': 'Roll',
  'demo.dice.rolledForReal': 'I rolled it for real',
  'demo.dice.totalPlaceholder': 'Total (required)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (optional)',
  'demo.dice.physLabelPlaceholder': 'Label (optional)',
  'demo.dice.logPhysical': 'Log physical roll',
  'demo.dice.onTable': '🎲 on-table',
  'demo.dice.private': 'Private',
  'demo.dice.public': 'Public',
  'demo.dice.rolledPrivately': 'rolled privately',
  'demo.dice.exploded': 'exploded',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Scene & cues',
  'demo.scene.current': 'Scene: {scene}',
  'demo.scene.cueSuffix': '— cue: {cue}',
  'demo.scene.noScene': 'No scene set',
  'demo.scene.oneShotCues': 'One-shot cues',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} at {x},{y}',
  'demo.map.tile': 'Tile {x},{y}',
  'demo.map.fogged': 'Fogged',
  'demo.map.battleMap': 'Battle map',
  'demo.map.gm': 'GM',
  'demo.map.noMap': 'No map',
  'demo.map.uploadedMap': 'Uploaded map',
  'demo.map.uploadTitle': 'Upload a map image as the canvas background',
  'demo.map.reading': 'Reading…',
  'demo.map.upload': 'Upload',
  'demo.map.size': 'Size',
  'demo.map.shrinkMap': 'Shrink map',
  'demo.map.growMap': 'Grow map',
  'demo.map.widthShort': 'W',
  'demo.map.narrowMap': 'Narrow map',
  'demo.map.widenMap': 'Widen map',
  'demo.map.heightShort': 'H',
  'demo.map.shortenMap': 'Shorten map',
  'demo.map.heightenMap': 'Heighten map',
  'demo.map.fitTitle': 'Reset position + stretch to fill the grid',
  'demo.map.fit': 'Fit',
  'demo.map.lock': 'Lock',
  'demo.map.adjust': 'Adjust',
  'demo.map.fogOn': 'Fog ON — click to disable',
  'demo.map.fogOff': 'Fog OFF — click to enable',
  'demo.map.fog': 'Fog',
  'demo.map.exitPaintTitle': 'Exit paint mode',
  'demo.map.paintTitle': 'Paint fog — click or drag cells to reveal/hide',
  'demo.map.exitPaint': 'Exit paint',
  'demo.map.paint': 'Paint',
  'demo.map.hexGridTitle': 'Hex grid — click for square',
  'demo.map.squareGridTitle': 'Square grid — click for hex',
  'demo.map.hex': 'Hex',
  'demo.map.zoomOut': 'Zoom out',
  'demo.map.zoomLevel': 'Zoom level',
  'demo.map.zoomIn': 'Zoom in',
  'demo.map.resetView': 'Reset view',
  'demo.map.reset': 'Reset',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': 'Expand {title}',
  'demo.dock.collapse': 'Collapse {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'Leave the table?',
  'demo.leave.heading': 'Leave the table?',
  'demo.leave.body':
    "You're in the middle of a game. This is a guest table — if you leave now, the session ends and your hero is lost.",
  'demo.leave.stay': 'Stay at the table',
  'demo.leave.leaveAnyway': 'Leave anyway',

  // ── DemoPage: LookStep (worlds that play at a city) ────────────────────────
  'demo.look.heading': 'Choose your look',
  'demo.look.subheading': 'Pick your people and a face. You will walk {city} as them.',
  'demo.look.lineages': 'Lineages and archetypes',
  'demo.look.portraits': 'Portraits',
  'demo.look.enter': 'Enter {city}',
  'demo.look.pickHint': 'Pick a portrait to continue.',

  // ── DemoPage: HumanStartStep (EvolveRPG, world config chargen.humanStarts) ─
  'demo.start.heading': 'Choose who you start as',
  'demo.start.subheading': 'Every choice is a whole EvolveRPG starting sheet. You will walk {city} in the figure shown.',
  'demo.start.pickHint': 'Pick a character to see their sheet and figure.',
  'demo.start.attribution': 'EvolveRPG and the Montkelian setting are World of Game Design originals.',
}
